module.exports = __webpack_public_path__ + "static/img/13.d50d04c5.png";